import { render, staticRenderFns } from "./ApplyPeralteeForm.vue?vue&type=template&id=b67dcf38&"
import script from "./ApplyPeralteeForm.vue?vue&type=script&lang=ts&"
export * from "./ApplyPeralteeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports